// Extract a user-facing error message from a failed request.
//
// Only the backend's own message is trusted (it's localized and
// meaningful): `response.data.detail.message` first, then the flatter
// `response.data.message`. Anything else — axios's raw
// "Request failed with status code 500", a thrown Error's `.message`,
// an SDK error `.name` — is NOT shown to the user; the caller's
// localized `fallback` is returned instead. Log the raw error to the
// console for debugging, never to a toast.
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    response?: {
      data?: {
        detail?: { message?: string };
        message?: string;
      };
    };
  };
  const backendMessage =
    e?.response?.data?.detail?.message || e?.response?.data?.message;
  return backendMessage || fallback;
}

export default getApiErrorMessage;
